// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Expand1: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M35.8 37.4c.3 0 .5-.1.7-.3l.5-.5c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7L7.1 5c-.4-.3-1.2-.3-1.6 0l-.5.5c-.3.4-.3 1.2 0 1.6l30.1 30c.2.1.5.3.7.3z"/><path d="M40.7 27h-.8c-.6 0-1 .4-1 1v11H28c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1h12.7c.6 0 1-.4 1-1V28c0-.6-.4-1-1-1zM15.1 2.1v-.8c0-.5-.5-1-1-1H1.3c-.6 0-1 .4-1 1V14c0 .6.4 1 1 1h.8c.6 0 1-.4 1-1V3.1h11c.6 0 1-.4 1-1z"/></svg>;
};

export default React.memo(Expand1);
